import React from "react";

export const Family = (props) => {
  return (
    <div id="family">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/familia.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="family-text">
              <h2>Programas de saúde para toda a família!</h2>
              <p>{props.data ? props.data.paragraph : "lCarregando..."}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>  <i class="fa fa-check" aria-hidden="true"></i>
 {d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> <i class="fa fa-check" aria-hidden="true"></i> 
 {d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
